/*
 * @Description: vuex 状态管理
 * @Author: jin
 * @Date: 2019-10-24 16:19:59
 */
import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js